/* Home Product Rail — hydrate the rail when source is `recommendations` or `recently_viewed`. */

(() => {
  const RECENTLY_VIEWED_KEY = 'theme:recently-viewed-products';

  function hideSection(grid) {
    const section = grid.closest('.home-product-rail');
    if (section) section.style.display = 'none';
  }

  function init() {
    document.querySelectorAll('.home-product-rail__grid').forEach((grid) => {
      const source = grid.dataset.source;
      if (source === 'recommendations') hydrateRecommendations(grid);
      if (source === 'recently_viewed') hydrateRecentlyViewed(grid);
    });
  }

  async function hydrateRecommendations(grid) {
    const limit = parseInt(grid.dataset.limit, 10) || 6;
    const intent = grid.dataset.intent || 'related';

    let productId = null;
    try {
      const recents = JSON.parse(localStorage.getItem(RECENTLY_VIEWED_KEY) || '[]');
      if (recents[0]) productId = recents[0].id || recents[0].productId;
    } catch (e) { /* ignore */ }

    if (!productId) {
      hideSection(grid);
      return;
    }

    try {
      const url = `${window.location.origin}/recommendations/products?section_id=&product_id=${productId}&limit=${limit}&intent=${intent}`;
      const res = await fetch(url);
      if (!res.ok) throw new Error('Recommendations fetch failed');
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const links = doc.querySelectorAll('a[href*="/products/"]');
      const seen = new Set();
      const cards = [];
      links.forEach((a) => {
        const href = a.getAttribute('href');
        if (!href || seen.has(href)) return;
        seen.add(href);
        const img = a.querySelector('img');
        if (!img) return;
        cards.push({ href, img: img.src || img.getAttribute('data-src'), title: a.textContent.trim().split('\n')[0] });
      });

      if (!cards.length) {
        hideSection(grid);
        return;
      }
      grid.innerHTML = '';
      cards.slice(0, limit).forEach((c) => grid.appendChild(buildCard(c)));
    } catch (e) {
      hideSection(grid);
    }
  }

  function hydrateRecentlyViewed(grid) {
    const limit = parseInt(grid.dataset.limit, 10) || 6;
    let recents = [];
    try {
      recents = JSON.parse(localStorage.getItem(RECENTLY_VIEWED_KEY) || '[]');
    } catch (e) { /* ignore */ }

    if (!recents.length) {
      hideSection(grid);
      return;
    }
    grid.innerHTML = '';
    recents.slice(0, limit).forEach((p) => {
      grid.appendChild(buildCard({
        href: p.url || `/products/${p.handle}`,
        img: p.image || p.featured_image || '',
        title: p.title || '',
      }));
    });
  }

  function buildCard(p) {
    const cell = document.createElement('div');
    cell.className = 'home-product-rail__cell';
    cell.innerHTML = `
      <a href="${p.href}" class="home-product-card">
        <div class="home-product-card__frame-wrap">
          <div class="home-frame home-frame--black">
            <div class="home-frame__mat">
              <div class="home-frame__art" style="background-image: url('${p.img}');"></div>
            </div>
          </div>
        </div>
        <div class="home-product-card__meta">
          <div class="home-product-card__title">${escapeHtml(p.title)}</div>
        </div>
      </a>
    `;
    return cell;
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
